export const PLUGIN_KEY = 'aks-insert-product-card';

export const MAX_COUNT = 9;

export enum AksInsertProductCardButton {
  InsertProductCard = 'aks-insert-product-card',
  EditProductCard = 'aks-edit-product-card',
  RemoveProductCard = 'aks-remove-product-card',
}
